module.exports = __webpack_public_path__ + "static/media/search-7.4782245b.png";